import { assistChipStyles } from './AssistChip.styles';
import { filterChipStyles } from './FilterChip.styles';
import { inputChipStyles } from './InputChip.styles';
import { suggestionChipStyles } from './SuggestionChip.styles';
export const chipVariantStyles = {
    assist: assistChipStyles,
    filter: filterChipStyles,
    input: inputChipStyles,
    suggestion: suggestionChipStyles,
};
